import { get, ndIsNaN } from '@/helpers/utilities';
import { formatCurrency, formatUnit, formatNumber } from '@/helpers/formatCurrency';
import store from './store';

export default {
  mixins: [store],
  mounted() {
    // emit the mounted event to parant component for notifying that finished lazy load
    this.$emit('mounted');
  },
  created() {
    // emit the created event to parant component for notifying that finished lazy load
    this.$emit('created');
  },
  computed: {
    publicPath() {
      return process.env.VUE_APP_ASSETS_URL;
    },
    isMobile() {
      const checkUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
      return checkUserAgent;
    },
    valuationCurrencyOptions() {
      return { decimals: 'optional' };
    },
  },
  methods: {
    ndIsNaN(value) {
      return ndIsNaN(Number(value));
    },
    formatCurrency(value, opt = {}) {
      const args = {
        currency: this.getters('app/getCurrency'),
        currencyDisplay: 'narrowSymbol',
        lang: this.getters('app/language'),
      };

      const formattedCurrency = formatCurrency(value, { ...args, ...opt });

      if (this.getters('app/country') === 'PL') return `${formattedCurrency} brutto`;

      return formattedCurrency;
    },
    formatNumber(value, opt = {}) {
      const args = {
        lang: this.getters('app/language'),
      };

      const formattedNumber = formatNumber(value, { ...args, ...opt });

      return formattedNumber;
    },
    formatUnit(value, opt = {}) {
      const args = {
        lang: this.getters('app/language'),
      };

      // unit must be passed
      const formattedUnit = formatUnit(value, { ...args, ...opt });

      return formattedUnit;
    },
    getters(key, args) {
      if (args) return this.$store.getters[`ndc/${key}`](args);
      return this.$store.getters[`ndc/${key}`];
    },
    state(key) {
      return get(this.$store.state.ndc, key);
    },
    commit(key, values) {
      return this.$store.commit(`ndc/${key}`, values);
    },
    dispatch(key, values) {
      return this.$store.dispatch(`ndc/${key}`, values);
    },
    hasModule(key) {
      return this.$store.hasModule(['ndc', key]);
    },
    registerModule(key, value) {
      if (this.hasModule(key)) return key;
      return this.$store.registerModule(['ndc', key], value);
    },
  },
};
